// extracted by mini-css-extract-plugin
export default {"container":"workSlider_container__LXiBg","canvas":"workSlider_canvas__TB9Cs","slider_count":"workSlider_slider_count__54b06","work_slider_main":"workSlider_work_slider_main__9WsRD"};